import { styled } from "@mui/material";
import { COLORS } from "assets";
import { Link } from "react-router-dom";

const StyledListItem = styled(Link, {
  shouldForwardProp: (prop) => prop !== "selected"
})<{
  selected?: boolean;
}>(({ theme: { transitions }, selected }) => ({
  backgroundColor: selected ? COLORS.custom.navActive : "transparent",
  textDecoration: "none",
  color: selected ? COLORS.custom.navActiveText : COLORS.white,
  width: "100%",
  marginBottom: 0,
  borderRadius: 10,
  paddingTop: 7,
  paddingBottom: 7,
  paddingLeft: 12,
  paddingRight: 12,
  display: "flex",
  alignItems: "center",
  gap: 12,
  ":hover": {
    backgroundColor: selected ? COLORS.custom.navActive : "rgba(255,255,255,0.06)",
    cursor: "pointer",
    color: selected ? COLORS.custom.navActiveText : "#fff"
  },
  ":visited": {
    color: "inherit"
  },
  transition: transitions.create(["background-color", "color"], {
    duration: transitions.duration.short,
    easing: transitions.easing.easeInOut
  })
}));

export default StyledListItem;
